var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "folders"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21135_3798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.848877,
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21135_3798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "folder_copy",
    d: "M5.22392 30.6249C4.42183 30.6249 3.7352 30.3393 3.16402 29.7681C2.59284 29.197 2.30725 28.5103 2.30725 27.7082V10.2082C2.30725 9.79505 2.44701 9.4487 2.72652 9.16918C3.00604 8.88967 3.35239 8.74991 3.76558 8.74991C4.17878 8.74991 4.52513 8.88967 4.80465 9.16918C5.08416 9.4487 5.22392 9.79505 5.22392 10.2082V27.7082H28.5572C28.9704 27.7082 29.3168 27.848 29.5963 28.1275C29.8758 28.407 30.0156 28.7534 30.0156 29.1666C30.0156 29.5798 29.8758 29.9261 29.5963 30.2056C29.3168 30.4852 28.9704 30.6249 28.5572 30.6249H5.22392ZM11.0573 24.7916C10.2552 24.7916 9.56854 24.506 8.99735 23.9348C8.42617 23.3636 8.14058 22.677 8.14058 21.8749V5.83325C8.14058 5.03116 8.42617 4.34453 8.99735 3.77335C9.56854 3.20217 10.2552 2.91658 11.0573 2.91658H17.1458C17.5347 2.91658 17.9053 2.9895 18.2578 3.13533C18.6102 3.28116 18.9201 3.48776 19.1875 3.75512L21.2656 5.83325H31.4739C32.276 5.83325 32.9626 6.11884 33.5338 6.69002C34.105 7.2612 34.3906 7.94783 34.3906 8.74991V21.8749C34.3906 22.677 34.105 23.3636 33.5338 23.9348C32.9626 24.506 32.276 24.7916 31.4739 24.7916H11.0573ZM11.0573 21.8749H31.4739V8.74991H20.0625L17.1458 5.83325H11.0573V21.8749Z",
    fill: "#141929"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.3ffc886f9f1dfe75d12a3445204866d6.svg";
export { ForwardRef as ReactComponent };